import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalVariadoService } from 'src/app/core/services/modal-variado/modal-variado.service';
import { RequestService } from 'src/app/core/services/request/request.service';

@Component({
    selector: 'app-multibeneficiario',
    templateUrl: './multibeneficiario.component.html',
    styleUrls: ['./multibeneficiario.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class MultiBeneficiarioComponent implements OnInit {
  data: any;
  documentosConArchivos: any[] = [];
  private blobStorageBaseUrl: string = 'https://colsstoragedigitalpru.blob.core.windows.net/requests/';
  panelVisibility: boolean[] = [];
  allDocumentsUploaded: boolean[] = [false, false];
  nombreTitular: string = '';

  constructor(private route: ActivatedRoute,
    public requestService: RequestService, public _ModalVariadoService: ModalVariadoService,) { }

  ngOnInit(): void {
    const navigation = window.history.state;
    this.data = navigation?.['data'] || null;

    if (this.data?.documentos) {
      this.panelVisibility = new Array(Object.keys(this.data.documentos).length).fill(true);
    } else {
      this.panelVisibility = [];
    }
    //this.nombreTitular = this.data ? this.obtenerNombresApellidosTitular(this.data) : '';
  }


  getBlobUrl(fileName: string): string {
    return `${this.blobStorageBaseUrl}${fileName}?nocache=${new Date().getTime()}`;
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  enviarTodosDocumentos(index: number, key: any): void {
    const documento = this.data.documentos[key];

    if (!documento?.selectedFile) {
      alert('Por favor seleccione un archivo para enviar.');
      return;
    }

    this.enviarDocumento(documento);

    this.panelVisibility[index] = false;

    this._ModalVariadoService.modalConfirmacion(
      'Tu documento ha sido cargado exitosamente. Recibirás una notificación cuando sea validado.'
    );
  }

  enviarDocumento(documento: any): void {
  if (!documento?.selectedFile) {
    alert('Por favor seleccione un archivo.');
    return;
  }

  this.requestService
    .actualizarDocumento(
      documento.id,
      documento.url,
      documento.selectedFile
    )
    .subscribe({
      next: (response: any) => {
        if (response?.status === 200 || response?.status === 'success') {
          let documentUrl: string | null = null;

          if (typeof response === 'string') {
            const urlMatch = response.match(/URL:\s*(.+)/);
            documentUrl = urlMatch ? urlMatch[1] : null;
          } else if (response?.url) {
            documentUrl = response.url;
          }

          console.log(
            'Documento actualizado correctamente',
            documentUrl ? `URL: ${documentUrl}` : ''
          );

          documento.enviado = true;
        } else {
          alert('El servidor respondió, pero la operación no fue exitosa.');
          console.error('Respuesta inesperada:', response);
        }
      },
      error: (err: any) => {
        console.error('Error al actualizar el documento:', err);
        alert('Ocurrió un error al enviar el documento. Intente nuevamente.');
      }
    });
}

  checkAllDocumentsUploaded(key: string, index: number): void {
    const documento = this.data.documentos[key];
    this.allDocumentsUploaded[index] = !!documento?.selectedFile;
  }

  onFileSelected(event: any, documento: any, key: string, i: number): void {
    const file = event.target.files[0];

    if (file && file.type === 'application/pdf') {
      documento.selectedFile = file;

      const index = this.documentosConArchivos.findIndex(d => d.id === documento.id);
      if (index === -1) {
        this.documentosConArchivos.push(documento);
      } else {
        this.documentosConArchivos[index] = documento;
      }
      this.checkAllDocumentsUploaded(key, i);
    } else {
      alert('Solo se permiten archivos PDF.');
    }
  }


  removeFile(documento: any, fileInput: HTMLInputElement, key: string, i: number): void {
    documento.selectedFile = null;
    fileInput.value = '';

    this.allDocumentsUploaded[i] = false;
  }

  obtenerNombresApellidosTitular(data: any): string {
    const documentosKeys = Object.keys(data.documentos);

    if (documentosKeys.length === 0) {
      return "";
    }

    const primeraClave = documentosKeys[0];
    const solicitud = data.documentos[primeraClave].documentos[0].documento.solicitudesComplementosEntity.solicitudesEntity;

    const primerNombre = solicitud && solicitud.primerNombreTitular ? solicitud.primerNombreTitular : "";
    const segundoNombre = solicitud && solicitud.segundoNombreTitular ? solicitud.segundoNombreTitular : "";
    const primerApellido = solicitud && solicitud.primerApellidoTitular ? solicitud.primerApellidoTitular : "";
    const segundoApellido = solicitud && solicitud.segundoApellidoTitular ? solicitud.segundoApellidoTitular : "";

    return `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim();
  }

  obtenerTipoPersona(key: string): string {
    if (!this.data?.documentos || !this.data.documentos[key]) {
      return 'Trámite';
    }

    const documentos = this.data.documentos[key];
    if (!documentos || documentos.length === 0) {
      return 'Trámite';
    }

    const sigla = documentos?.sigla_tipo_solicitud;

    switch (sigla) {
      case 'AFT':
        return 'Titular';
      case 'AFB':
        return 'Beneficiario';
      default:
        return 'Trámite';
    }
  }

  obtenerMensajeObservaciones(observaciones: string): string {
    if (!observaciones) {
      return '';
    }
    if (observaciones.trim().startsWith('{')) {
      try {
        const parsed = JSON.parse(observaciones);
        return parsed.observaciones;
      } catch (e) {
        return observaciones;
      }
    }
    return observaciones;
  }

  obtenerNombreDesdeContrato(contratoJson: string | any): string {
    try {
      if (!contratoJson) {
        return '';
      }

      const contrato = typeof contratoJson === 'string'
        ? JSON.parse(contratoJson)
        : contratoJson;

      const datosBasicos =
        contrato?.beneficiario?.datosBasicos ||
        contrato?.datosBasicos;

      if (!datosBasicos) {
        return '';
      }

      const {
        primerNombre,
        segundoNombre,
        primerApellido,
        segundoApellido
      } = datosBasicos;

      return [
        primerNombre,
        segundoNombre,
        primerApellido,
        segundoApellido
      ]
        .filter(valor => valor && valor.trim() !== '')
        .join(' ')
        .trim();

    } catch (error) {
      console.error('Error procesando contrato:', error);
      return '';
    }
  }
}
